<template>
  <div>
    <div class="d-flex justify-content-between align-items-center p-0">
      <div class="col-auto">
        <span class="p-2">
          Facture Référence Nº :
          <span class="fw-bold">
            {{ $route.params.reference }}
          </span>
        </span>
      </div>
      <div class="col-auto row">
        <div
          v-if="transaction.reference && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button @click="refresh()" class="btn border">
            <i class="bi bi-check2-square text-secondary fs-4"></i> Valider
          </button>
        </div>

        <div
          v-if="transaction.reference && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="
              $router.push({
                name: 'transactions-edit',
                params: { reference: transaction.reference },
              })
            "
            class="btn border"
          >
            <i class="bi bi-pencil-square text-secondary fs-4"></i> Modifier
          </button>
        </div>
        <div v-if="transaction.reference" class="col-auto p-1">
          <button @click="print(transaction.reference)" class="btn border">
            <i class="bi bi-printer text-secondary fs-4"></i> Imprimer
          </button>
        </div> 

        <div
          v-if="transaction.reference && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button @click="remove(transaction)" class="btn border">
            <i class="bi bi-trash text-secondary fs-4"></i> Supprimer
          </button>
        </div>
        <div class="col-auto p-1">
          <button @click="refresh()" class="btn border">
            <i class="bi bi-arrow-clockwise text-secondary fs-4"></i> Actualiser
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="row align-items-stretch" id="printMe">
      <div class="col-6">
        <!-- customer name -->
        <div class="row justify-content-between">
          <div class="col p-1">Client</div>
          <div class="col p-1 fw-bold">
            <span
              v-if="transaction.customer"
              :class="
                transaction.customer.fullName.includes('Bloqué')
                  ? 'text-danger'
                  : ''
              "
              class="fw-bold"
            >
              {{ transaction.customer.fullName }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nº de Téléphone</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer" class="fw-bold">
              {{ transaction.customer.phone }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nom Commercial (Société)</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer" class="fw-bold">
              {{ transaction.customer.society }}
            </span>
          </div>
        </div>
      </div>

      <!-- paiments -->
      <div class="col-6 justify-content-between">
        <div class="row">
          <div class="col p-1">Total Payé :</div>
          <div v-if="transaction.amount" class="col p-1 fw-bold">
            {{ transaction.amount | toFixedWithSpace }} Dh
          </div>
          <div v-else class="col p-1 fw-bold text-danger">----------</div>
        </div>

        <div class="row">
          <div class="col p-1">Montant en lettres :</div>
          <div
            v-if="transaction.writtenAmount"
            class="col p-1 fw-bold text-uppercase"
          >
            {{ transaction.writtenAmount }} Dh
          </div>
          <div v-else class="col p-1 fw-bold text-danger">----------</div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Impayé :</div>
          <div v-if="transaction.remainingAmount" class="col p-1 fw-bold">
            {{ transaction.remainingAmount | toFixedWithSpace }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Mode de paiement :</div>
          <div v-if="transaction.paymentMethod" class="col p-1 fw-bold">
            {{ transaction.paymentMethod }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Nº de chéque :</div>
          <div v-if="transaction.paymentMethod" class="col p-1 fw-bold">
            {{ transaction.checkNumber }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Nº de Virement :</div>
          <div v-if="transaction.paymentMethod" class="col p-1 fw-bold">
            {{ transaction.bankTransferNumber }}
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="row align-items-stretch">
      <div class="col-6">
        <div class="row justify-content-between">
          <div class="col p-1">Vérifié (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer"> - </span>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="row justify-content-between">
          <div class="col p-1">Validé (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.validated"> Validee </span>
            <span v-else class="bg-warning rounded p-1"> En Attente </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="transaction.customer"> - </span>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-auto p-1">Remarque :</div>
    <div class="col p-1 fw-bold">
      {{ transaction.remark }}
    </div>
    <br />

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Facture Réf</th>
          <th scope="col">Date</th>
          <th scope="col">M. Facture</th>
          <th scope="col">M. Payé</th>
          <th scope="col">M. Impayé</th>
          <th scope="col">Créer par</th>
        </tr>
      </thead>
      <!-- {{ transaction.transaction_sales }} -->
      <tbody>
        <tr
          v-for="(transactionSale, index) in transaction.transaction_sales"
          :key="index++"
        >
          <td>
            {{ index }}
          </td>
          <td>
            {{ transactionSale.sale_reference }}
          </td>

          <td>{{ transactionSale.date }}</td>

          <td>
            <span v-if="transactionSale.sale">
              <span v-if="transactionSale.sale.totalPriceTTC >= 0">
                {{ transactionSale.sale.totalPriceTTC }}
              </span>
            </span>
          </td>

          <td class="text-success fw-bold">
            <span v-if="transactionSale.amount >= 0">
              {{ transactionSale.amount | toFixedWithSpace }}
            </span>
          </td>
          <td class="text-danger">
            <span v-if="transactionSale.remainingAmount">
              {{ transactionSale.remainingAmount | toFixedWithSpace }}
            </span>
          </td>
          <td>
            <span v-if="transactionSale.user">
              {{ transactionSale.user.name }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("transaction/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("transaction", {
      transaction: "getTransaction",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("transaction/show", this.$route.params.reference);
    },

    async remove(data) {
      let transaction = data;
      await this.$confirm({
        message:
          "Vous voulez le paiement  " +
          transaction.reference +
          "  Montant de : " +
          transaction.amount,
        button: {
          no: "Non",
          yes: "Oui",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("transaction/destroy", transaction.reference);
          }
        },
      });
    },

    async print(reference) {
      await this.$store.dispatch("transaction/printReceipt", reference);
    },
  },

  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>
